export const GET_USER_NOTIFICATION_CONFIG_REQUEST = "GET_USER_NOTIFICATION_CONFIG_REQUEST";
export const GET_USER_NOTIFICATION_CONFIG_SUCCESS = "GET_USER_NOTIFICATION_CONFIG_SUCCESS";
export const GET_USER_NOTIFICATION_CONFIG_FAILURE = "GET_USER_NOTIFICATION_CONFIG_FAILURE";

export const UPDATE_USER_NOTIFICATION_CONFIG_REQUEST = "UPDATE_USER_NOTIFICATION_CONFIG_REQUEST";
export const UPDATE_USER_NOTIFICATION_CONFIG_SUCCESS = "UPDATE_USER_NOTIFICATION_CONFIG_SUCCESS";
export const UPDATE_USER_NOTIFICATION_CONFIG_FAILURE = "UPDATE_USER_NOTIFICATION_CONFIG_FAILURE";


export const getUserNotificationConfigRequest = () => ({
    type: GET_USER_NOTIFICATION_CONFIG_REQUEST,
});

export const getUserNotificationConfigSuccess = (notificationConfig) => ({
    type: GET_USER_NOTIFICATION_CONFIG_SUCCESS,
    payload: notificationConfig,
});

export const geUserNotificationConfigFailure = (error) => ({
    type: GET_USER_NOTIFICATION_CONFIG_SUCCESS,
    payload: error,
});

export const updateUserNotificationConfigRequest = (updatedConfig) => ({
    type: UPDATE_USER_NOTIFICATION_CONFIG_REQUEST,
    payload: updatedConfig,
});

export const updateUserNotificationConfigSuccess = (updatedConfig) => ({
    type: UPDATE_USER_NOTIFICATION_CONFIG_SUCCESS,
    payload: updatedConfig,
});

export const updateUserNotificationConfigFailure = (error) => ({
    type: UPDATE_USER_NOTIFICATION_CONFIG_FAILURE,
    payload: error,
});
